<template>
  <mk-drawer-biz-two
    class="setting-dialog"
    title="文章同步设置"
    :append-to-body="true"
    :modal-append-to-body="true"
    size="500px"
    :visible="visible"
    :with-bottom="false"
    @close="$emit('update:visible', false)"
  >
    <div class="content">
      <div class="mention">
        <i class="el-icon-info"></i>
        通过公众号文章时，会应用相关的设置内容
      </div>
      <div class="setting-list">
        <div class="setting-item">
          <div class="setting-title">
            同步历史文章
          </div>
          <div class="setting-content">
            <div class="description">
              若同步历史文章，系统首次同步时，会将公众号往前3个月发布的内容，全部同步到素材库中
            </div>
            <div class="setting-switch">
              <mk-switch
                :value="settingInfo.isSyncHistory === 1 ? true : false"
                active-color="#009CFF"
                inactive-color="#BFBFBF"
                @click.native="handleSwitchChange('isSyncHistory', settingInfo.isSyncHistory)"
              >
              </mk-switch>
            </div>
          </div>
        </div>
        <div class="setting-item">
          <div class="setting-title">
            自动发布
          </div>
          <div class="setting-content">
            <div class="description">
              开启后，系统同步的公众号文章，会自动发布
            </div>
            <div class="setting-switch">
              <mk-switch
                :value="settingInfo.releaseStatus === 1 ? true : false"
                active-color="#009CFF"
                inactive-color="#BFBFBF"
                @click.native="handleSwitchChange('releaseStatus', settingInfo.releaseStatus)"
              >
              </mk-switch>
            </div>
          </div>
        </div>
        <!-- 个微没有 -->
        <!-- <div class="setting-item">
          <div class="setting-title">
            员工二维码
          </div>
          <div class="setting-content">
            <div class="description">
              开启后，员工分享出去的文章，会附带自己的二维码
            </div>
            <div class="setting-switch">
              <mk-switch
                :value="settingInfo.isShowQRCode === 1 ? true : false"
                active-color="#009CFF"
                inactive-color="#BFBFBF"
                @click.native="handleSwitchChange('isShowQRCode', settingInfo.isShowQRCode)"
              >
              </mk-switch>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </mk-drawer-biz-two>
</template>

<script>
import MkDrawerBizTwo from '@components/mk-drawer-biz-two'
export default {
  name: 'SettingDialog',
  components: {
    MkDrawerBizTwo
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    settingInfo: {
      type: Object,
      default: () => {
        return {
          // 是否同步历史文章 1同步 2不同步
          isSyncHistory: 2,
          // 发布状态  1发布，2不发布
          releaseStatus: 2,
          // 是否显示二维码  1显示 2不显示
          isShowQRCode: 2,
          // 是否正在加载
          isLoading: false
        }
      }
    }
  },
  methods: {
    handleSwitchChange (key, val) {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      val = val === 2 ? 1 : 2
      let data = this._.cloneDeep(this.settingInfo)
      data[key] = val
      delete data.isSync
      delete data.isShowQRCode
      this.articleSyncJobSavePost(data)
    },
    // 文章同步设置
    async articleSyncJobSavePost (params) {
      const { success, data } = await WXMPSVCAPIS.ArticleSyncJobApi.articleSyncJobSavePost(params)
      this.isLoading = false
      if (success) {
        this.$message.success('设置成功')
        this.$emit('on-setting-change')
      } else {
        this.$message.error('设置失败')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  .mention {
    display: flex;
    align-items: center;
    height: 36px;
    background-color: #f2fbff;
    border: 1px solid #ccecff;
    padding: 0 8px;
    font-size: 13px;
    color: #262626;

    .el-icon-info {
      color: #1b9aee;
      font-size: 16px;
      margin-right: 8px;
    }
  }

  .setting-list {
    margin: 0 20px;

    .setting-item {
      margin-top: 12px;
      padding-bottom: 12px;
      border-bottom: 1px solid #f0f0f0;

      .setting-title {
        font-size: 13px;
        color: #595959;
        line-height: 18px;
      }

      .setting-content {
        margin-top: 4px;
        display: flex;
        justify-content: space-between;

        .description {
          font-size: 13px;
          color: #888;
          line-height: 18px;
        }

        .setting-switch {
          margin-left: 46px;
        }
      }
    }
  }
}

/deep/ .drawer-content {
  padding: 0 !important;
}
</style>
